interface BrandMarkProps {
  compact?: boolean
  light?: boolean
}

export function BrandMark({ compact = false, light = false }: BrandMarkProps) {
  return (
    <div className={`brand-mark ${compact ? 'brand-mark--compact' : ''} ${light ? 'brand-mark--light' : ''}`} aria-label="DAWN OS">
      <svg viewBox="0 0 48 48" aria-hidden="true">
        <defs>
          <linearGradient id="dawnGradient" x1="4" y1="42" x2="44" y2="6" gradientUnits="userSpaceOnUse">
            <stop stopColor="#48D9CF" />
            <stop offset="0.55" stopColor="#D6B36A" />
            <stop offset="1" stopColor="#F6E4B7" />
          </linearGradient>
        </defs>
        <circle cx="24" cy="24" r="19" fill="none" stroke="url(#dawnGradient)" strokeWidth="1.5" />
        <path d="M10 28h28" stroke="url(#dawnGradient)" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M15 23a9 9 0 0 1 18 0" fill="none" stroke="url(#dawnGradient)" strokeWidth="2" strokeLinecap="round" />
        <path d="M24 10v5M13.5 15.5l3.5 3.2M34.5 15.5 31 18.7" stroke="url(#dawnGradient)" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="24" cy="28" r="2.2" fill="#D6B36A" />
      </svg>
      <div>
        <strong>DAWN</strong>
        {!compact && <span>Digital Agent Workflow Network</span>}
      </div>
    </div>
  )
}
